import api from "../api";

const state = {
  issue: {},
};

const actions = {
  async postIssue({ commit }, data) {
    try {
      await api.sendIssue(data);
    } catch (err) {
      throw err;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
};
